exports.components = {
  "component---src-pages-01-js": () => import("./../../../src/pages/01.js" /* webpackChunkName: "component---src-pages-01-js" */),
  "component---src-pages-02-js": () => import("./../../../src/pages/02.js" /* webpackChunkName: "component---src-pages-02-js" */),
  "component---src-pages-03-js": () => import("./../../../src/pages/03.js" /* webpackChunkName: "component---src-pages-03-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

